var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000000863(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#4AC8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.412 24.926 2.304-2.121a4.33 4.33 0 0 0 1.115-4.69l-.982-2.637a4.123 4.123 0 0 0-2.032-2.256 4.093 4.093 0 0 0-3.018-.245c-3.682 1.132-6.511 4.57-5.64 8.653.573 2.686 1.669 6.057 3.745 9.644a34.292 34.292 0 0 0 6.496 8.118c3.077 2.813 7.475 2.11 10.304-.541a4.107 4.107 0 0 0 .367-5.596l-1.802-2.199a4.29 4.29 0 0 0-2.093-1.396 4.271 4.271 0 0 0-2.513.02l-2.978.943a14.285 14.285 0 0 1-2.008-2.636 13.546 13.546 0 0 1-1.265-3.063v.002z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000000863);
export default __webpack_public_path__ + "static/media/Group 1000000863.0e2419fafdc7ed0a562167edd3bf812f.svg";
export { ForwardRef as ReactComponent };